class Customer.AsyncJob extends Backbone.View

  start: (jobsName, params) =>
    @job = new ResqueJob
      url: "/customer/jobs/#{jobsName}"
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: =>
        @trigger('failed')
    @job.start()

  stop: ->
    @job.stop()
